module.exports = __webpack_public_path__ + "static/img/5.36f3c137.svg";